import { combineReducers } from 'redux'

import installation from 'apps/applicationInstallation/reducers'
import { reducer as listReducer } from 'apps/applications/redux/applications'
import { reducer as settingsReducer } from 'apps/applications/redux/installedApplications'
import { reducer as publish } from 'apps/applications/redux/publish'
import updateApplication from 'common/settings/components/SettingsPanel/AppSection/installedApplications/reducers/updateInstalledApplication'
import { usesListReducer } from 'common/settings/components/SettingsPanel/AppSection/installedApplications/reducers/usesListReducer'

import current from './currentApplication'
import reviewReport from './reviewReport'

export default combineReducers({
  current,
  installation,
  list: listReducer,
  publish,
  reviewReport,
  settings: settingsReducer,
  updateApplication,
  usesList: usesListReducer,
})
